import React from 'react';
import {
  PayPalScriptProvider,
} from "@paypal/react-paypal-js";
import ButtonWrapper from './ButtonWrapper';

const Venmo = (props) => {
  console.log(props.props, ' from venmo component');
  const accessToken = 'AdGRyMyfabg_0tqNbnKtDb3Sdy79JvHBOedyQKRZuMBt0TFBlJxbz_VqKgWHXp3xoL_wA5ATIIl-Nxmo';
  // replace with your actual Venmo access token
  const payload = {
    user_id: 'recipient_user_id',
    amount: 10.00,
    note: 'Payment note',
    audience: 'public',
  };

  const initialOptions = {
    "client-id": "test",
    currency: "USD",
    intent: "capture",
    "data-client-token": "abc123xyz==",
  };
  // process.env.REACT_APP_VENMO_CLIENTID
  return (
    <>
      <div className='venmo_main_div'>
        <PayPalScriptProvider
          options={{
            "client-id": process.env.REACT_APP_VENMO_CLIENTID,
            components: "buttons",
            currency: "USD",
            "enable-funding": "venmo"
          }}
        >
          <ButtonWrapper
            currency={"USD"}
            showSpinner={false}
            props={props.props}
          />
        </PayPalScriptProvider>
      </div>
    </>
  )
}

export default Venmo;